import { computed, effect, inject, Injectable, OnDestroy, signal } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

import { FilterService } from '../filter/filter.service';
import { PagerMode } from './model/pager-show-mode';
import { toObservable } from '@angular/core/rxjs-interop';


const initialPageSize = 15;
const initialPagerMode: PagerMode = 'hidden';

@Injectable()
export class PagerService
    extends FilterService
{
    // private readonly _filterService = injectRequired(FilterService);

    pagerMode$$ = signal<PagerMode>(initialPagerMode);
    
    private __listCount$ = new BehaviorSubject<number>(0);
    listCount$ = this.__listCount$.asObservable();
    get ListCount() { return this.__listCount$.value; }

    private __pageNumber$ = new BehaviorSubject<number>(1);
    pageNumber$ = this.__pageNumber$.asObservable();
    get PageNumber(): number {return this.__pageNumber$.value;}
    set PageNumber(value) {
        const _currValue = this.__pageNumber$.value;

        if (value != null && value != _currValue) {
            this.__pageNumber$.next(value);
        }
    }

    private __pagerShow$$ = signal<boolean>(false);
    // private _pagerShow$ = new BehaviorSubject<boolean>(false);
    pagerShow$$ = computed(() => this.__pagerShow$$());
    pagerShow$ = toObservable(this.__pagerShow$$);
    // get PagerShow() { return this._pagerShow$.value; }
    // set PagerShow(value) {
    //     const _currValue = this._pagerShow$.value;

    //     if (value != null && value !== _currValue) {
    //         this._pagerShow$.next(value);
    //     }
    // }

    private __pageSize$ = new BehaviorSubject<number | null>(null);
    pageSize$ = this.__pageSize$.asObservable();
    get PageSize() {return this.__pageSize$.value;}

    listCount_set(listCount: number) {
        const _currValue = this.__listCount$.value;

        if (listCount != null && listCount != _currValue) {
            this.__listCount$.next(listCount);
            this.pageSize_set();
        }
    }
    page_reset(): void {
        const _page = this.PageNumber;

        if (_page != 1) {
            this.PageNumber = 1;
        }
    }

    // private __size_change(value: number) {
    //     // this.size = value;
    //     this.page_reset();
    // }

    pageSize_set(pageSize?: number): void {
        let _pageSize = pageSize ?? this.PageSize ?? initialPageSize;
        const _listSize = this.ListCount;
        const _pagerShow = this.pagerShow$$();
        const _multiPage = _listSize > _pageSize;

        const _newPageSize = _pagerShow && _multiPage ? _pageSize : 0;

        if (_newPageSize !== _pageSize) {
            this.__pageSize$.next(_newPageSize);
        }
    }

    // private __size_reset() {
    //     this._size_change(0);
    // }  

    pagerMode_get(): PagerMode {
        const _filterShow = this.filterShow$$();
        const _pagerMode_initial = initialPagerMode;
        const _pagerShow = this.pagerShow$$();

        return _filterShow && _pagerShow ? 'pagerAndFilter'
            : _pagerShow ? 'pager'
            : _filterShow ? 'filter'
            : _pagerMode_initial;
    }

    pagerMode_set(pagerMode: PagerMode): void;
    pagerMode_set(pagerShow: boolean, filterShow?: boolean): void;
    pagerMode_set(value1: PagerMode | boolean, filterShow?: boolean): void {
        const _pagerMode = this.pagerMode$$();
        let _newPagerMode: PagerMode;

        if (typeof(value1) == 'boolean' ) {
            const _pagerShow = value1;
            const _filterShow = filterShow ?? false;

            if (_filterShow) {
                _newPagerMode = _pagerShow ? 'pagerAndFilter' : 'filter';
            } else {
                _newPagerMode = _pagerShow ? 'pager' : 'hidden';
            }
        } else {
            _newPagerMode = value1;
        }

        if (_newPagerMode != _pagerMode) {
            this.pagerMode$$.set(_newPagerMode);
        }
    }

    // pagerShow_set(value: boolean): void {
    //     this._pagerShow$$.set(value);
    // }
}
